import {connect} from 'react-redux';

import {
  AppParametricSelector,
  makeMapDispatchToProps,
  makeMapStateToProps,
} from '../../../srcCommon/helpers/reselectHelpers';
import {makeGetHasCellsFilters} from '../../../srcCommon/inboxes/cells/cellsFiltersSelectors';
import {updateSizeAction} from '../../store/data/localPreferences/localPreferencesActions';
import {getSizes} from '../../store/data/localPreferences/localPreferencesSelectors';
import {clearOfflineDrafts, reopenOfflineDraftMessages} from '../../store/data/offline/offlineActions';
import {getUserStarredTagId} from '../../store/data/tags/tagsSelectors';
import {getUser} from '../../store/data/teammates/teammatesSelectors';
import {
  getShouldShowEditModeHelpTip,
  getShouldShowP1AutoRecBanner,
} from '../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {
  getHasP1AutoRec,
  getShouldHideAssignedConversations,
} from '../../store/featureFlags/featureFlagsSelectors';
import {replaceParametersAction} from '../../store/panels/app/appPanelRouteActions';
import {AppContentTypesEnum} from '../../store/panels/app/parameters/appParameters';
import {makeGetCellsPanelCurrentPage} from '../../store/panels/cells/cellsPanelSelectors';
import {
  makeGetInboxesIsEditingWorkspaces,
  makeGetInboxesParameters,
} from '../../store/panels/inboxes/inboxesPanelSelectors';
import {InboxesParameters} from '../../store/panels/inboxes/parameters/inboxesParameters';
import {InboxesPanelId, makeCellsPanelId} from '../../store/panels/panelStateBase';
import {Inboxes} from './inboxes';

/*
 * Props.
 */

interface InboxesContainerProps {
  panelId: InboxesPanelId;
}

/*
 * Selectors.
 */

function makeGetCellsCurrentParameters(): AppParametricSelector<InboxesContainerProps, InboxesParameters> {
  const getCellsPanelPage = makeGetCellsPanelCurrentPage<InboxesContainerProps>((_state, props) =>
    makeCellsPanelId(props.panelId),
  );

  return (state, props) => getCellsPanelPage(state, props).parameters;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<InboxesContainerProps>()(() => ({
  user: getUser,
  sizes: getSizes,
  parameters: makeGetInboxesParameters(),
  isEditingWorkspaces: makeGetInboxesIsEditingWorkspaces(),
  // Use the current cells panel page to look up the filters, because that matches the CellsHeaderContainer behavior.
  hasCellsFilters: makeGetHasCellsFilters(makeGetCellsCurrentParameters()),
  hasP1AutoRec: getHasP1AutoRec,
  shouldShowP1AutoRecBanner: getShouldShowP1AutoRecBanner,
  shouldShowEditModeHelpTip: getShouldShowEditModeHelpTip,
  starredTagId: getUserStarredTagId,
  shouldHideAssignedConversations: getShouldHideAssignedConversations,
}));

const mapDispatchToProps = makeMapDispatchToProps<InboxesContainerProps>()(({panelId}) => ({
  onParametersChange: (parameters: InboxesParameters) =>
    replaceParametersAction(panelId, {
      contentType: AppContentTypesEnum.INBOXES,
      parameters,
    }),
  updateSize: updateSizeAction,
  reopenOfflineDraftMessages,
  clearOfflineDrafts,
}));

export const InboxesContainer = connect(mapStateToProps, mapDispatchToProps)(Inboxes);
